import { ISterilisationEquipment } from '@principle-theorem/principle-core/interfaces';
import { AtLeast } from '@principle-theorem/shared';

export class SterilisationEquipment {
  static init(
    overrides: AtLeast<ISterilisationEquipment, 'name'>
  ): ISterilisationEquipment {
    return {
      deleted: false,
      ...overrides,
    };
  }
}
